export enum ShopAction {
  REMOVE = 'remove',
  VERIFY = 'verify',
}

export default { ShopAction };
